import * as _ from 'lodash';
import React, { useState, useEffect } from 'react';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import FindClientDialog from  'src/components/client-project/dialogs/FindClientDialog';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import CPNavBar from '../CPNavBar';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
// import Select from 'react-select';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import TagContainer from 'src/components/counties/TagContainer';
import State from 'src/models/State';
import County from 'src/models/County';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import PagedResultSet from 'src/models/common/PagedResultSet';
import TsdiClient from 'src/models/AP/Client';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import { MdHistory } from 'react-icons/md';
import { FaTrash } from 'react-icons/fa';
import { FaUserTie } from 'react-icons/fa';
import { FaRegSave } from 'react-icons/fa';
import { BsSearch } from 'react-icons/bs';
import { FaFileAlt } from 'react-icons/fa';
import { VscGraph } from 'react-icons/vsc';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import FindProjectDialog from '../dialogs/FindProjectDialog';

const ProjectMaintenancePage = () => {
    const dispatch = useDispatch();
    // const { get, post, del, put, response } = useFetch();
    // const { register, reset, setValue, getValues, handleSubmit, errors, formState } = useForm();
    const { register: registerState, /*reset: resetState*/ } = useForm();
    const { register, errors, reset, getValues} = useForm();
    const { register: registerClientValues, reset: resetClientValues } = useForm();
    const { get, post, put, response } = useFetch();
    const [projects, setProjects] = useState<ProspectDetails[]>(undefined);
    const [projectTypes, setProjectTypes] = useState<{ code: number, description: string}[]>(undefined);
    const [currentMileageRate, setCurrentMileageRate] = useState<number>(undefined);
    const [selectedState, setSelectedState] = useState<number>(undefined);
    const [clientStateId, setClientStateId] = useState<number>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [stateCounties, setStateCounties] = useState<PagedResultSet<County>>(undefined);
    const [selectStates, setSelectStates] =  useState<Array<{ value: string; label: string }>>(undefined);
    const [selectStateCounties, setSelectStateCounties] = useState<Array<SelectItem>>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
    const [fetchNextClientsPage, setFetchNextClientsPage] = useState<boolean>(true);
    const [applyBdBonus, setApplyBdBonus] = useState<boolean>(false);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const [addingProject, setAddingProject] = useState<boolean>(false);
    const [saveCountiesRef, setSaveCountiesRef] = useState<HTMLButtonElement>(null);
    const [countiesForUpdate, setCountiesForUpdate] = useState<Array<County>>(null);
    // const { isDirty, dirtyFields } = formState;

    // Initial render
    useEffect(() => {
        onCreate();

        // TODO: *cry* 😭✅
        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!countiesForUpdate) {
            updateProject(generateUpdatePayload());
        }
    }, [countiesForUpdate]);

    useEffect(() => {
        if (!!addingProject) {
            showDialog(DialogList.FIND_PROJECT);
        }
    }, [addingProject]);

    useEffect(() => {
        if (states?.items?.length) {

            let list = states?.items?.map(s => {
                return {
                    label: (!!s.name ? `(${s.name})` : ''),
                    value: `${s.id}` };
            });
            setSelectStates(list);
        }
    }, [states]);

    useEffect(() => {
        if (!!selectStates) {
            console.log(selectStates[0]);
        }
    }, [selectStates]);

    useEffect(() => {
        if (!!stateCounties && stateCounties?.items?.length > 0) {
            setSelectStateCounties(stateCounties ? stateCounties?.items?.map((c: County) => new SelectItem(c.id, c.name)) : undefined);
        }
    }, [stateCounties]);

    useEffect(() => {
        if ((!!clientSearchTerm || clientSearchTerm === '') && !!clientSearchOptions) {
            resetClientSearchOptions();
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        getClients();
    }, [clientSearchOptions]);

    useEffect(() => {
        if (!!clients && clients.length > 0) {
            prepFormData();
            getStatesCounties(clientStateId);
        }
    }, [clients]);

    useEffect(() => {
        if (!!selectedClient) {
            if (!!clients && clients?.length > 0) {
                resetClientValues({ clientNumber: selectedClient?.clientNumber, clientName: selectedClient?.clientName });
            }
            getStatesCounties(clientStateId);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (!!selectedProject) {
            populateProjectForm();
            if (!!selectedClient?.clientNumber && !!selectedClient?.clientName) {
                resetClientValues({ clientNumber: selectedClient.clientNumber, clientName: selectedClient.clientName});
            }
        }
    }, [selectedProject]);

    useEffect(() => {
        if (!!selectedState) {
            // resetState({ value: selectedState, label: });
            console.log(selectedState);
        }
    }, [selectedState]);

    const onCreate = () => {
        // Put all initialization code here.
        setClientStateId(40);
        initializeClientSearchSettings();
        getStates();
        getClientTypes();
        if (!projects) {
            setProjects([]);
        }
        getCurrentMileageRate();
        const saveCountiesButtonRef = document.getElementById('saveCountiesButton') as HTMLButtonElement;
        if (!!saveCountiesButtonRef) {
            setSaveCountiesRef(saveCountiesButtonRef);
        }
    };

    const getCurrentMileageRate = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/client/billing/mileagerate/current`);

        if (response.ok) {
            setCurrentMileageRate(result);
        } else {
            setCurrentMileageRate(.7);
            console.log('Unable to get mileage rate!');
        }
    };

    const onDestroy = () => {
        // Put all destruction code here.
    };

    const hideDialog = () => {
        setAddingProject(false);
        dispatch(actions.layout.hideDialog());
    };

    const onCancel = () => {
        setAddingProject(false);
        dispatch(actions.layout.hideDialog());
    };

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const prepFormData = () => {
        if (!!clients && clients?.length > 0) {
            console.log(clients[0]);
        }
    };

    const populateProjectForm = () => {
        setApplyBdBonus(selectedProject.bdBonus);
        reset(selectedProject);
    };

    const onStateSelected = (id: number) => {
        setSelectedState(id);
        getStatesCounties(id);
    };

    const getStatesCounties = async (id: number) => {
        const result = await get(`/v1.0/States/${id}/counties`);

        if (result) {
            setStateCounties(result);
        } else {
            console.log('Unable to retrieve the Counties for selected State.');
        }
    };

    const getStates = async () => {
        const result = await get(`/v1.0/states`);

        if (response.ok) {
            setStates(result);
        } else {
            console.log('Unable to retrieve States data.');
        }
    };

    const deleteProject = () => {
        alert('Delete a project');
    };

    const displayTitle = () => {
        const title = 'Project Maintenance';

        return title;
    };

    const displayHeading2 = () => {
        const title = 'Project Settings';

        return title;
    };

    const addProject = async (payload: ProspectDetails) => {
        let result = await post(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok) {
            getProject(selectedClient?.clientNumber, result);
        }
    };

    const getProject = async (clientNumber: number, projectNumber: number) => {
        let result = await get(`/v1.0/ClientProjectMaintenance/project/${projectNumber}/client/${clientNumber}`);

        if (response.ok) {
            setSelectedProject(result);
        }
    };

    const updateProject = async (payload: ProspectDetails) => {
        let result = await put(`/v1.0/ClientProjectMaintenance/project`, payload);

        if (response.ok && result === 1) {
            getProject(selectedClient?.clientNumber, selectedProject?.number);
        }
    };

    const getClientTypes = async () => {
        let result = await get(`/v1.0/ClientProjectMaintenance/clients/types`);
        setProjectTypes([]);
        if (response.ok) {
            setProjectTypes(result);
        }
    };

    const resetClientSearchOptions = () => {
        setFetchNextClientsPage(true);
        console.log(fetchNextClientsPage);
        let newClientSearchOptions = _.cloneDeep(clientSearchOptions);
        newClientSearchOptions.clearFilters();
        newClientSearchOptions.addPaging(1, 50);
        const fieldValues = clientSearchTerm.split(',');
        newClientSearchOptions.addFilter(new ODataFilter('CL_NO', ODataFilterOperators.Equals, !!clientSearchTerm ? fieldValues[0] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('NAME1', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[1] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('NAME2', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[2] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('CITY', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[3] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('STATE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[4] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('ZIP', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[5] : ''));
        newClientSearchOptions.addFilter(new ODataFilter('PHONE', ODataFilterOperators.Contains, !!clientSearchTerm ? fieldValues[6] : ''));
        setClientSearchOptions(newClientSearchOptions);
    };

    const displayProjectSettingButtons = () => {
        return (
            <>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Find Project"
                    reactIcon={BsSearch}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findProject(false)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Project"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToFirstProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Project"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToPreviousProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Add New Project"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => setAddingProject(true)}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Delete Project"
                    reactIcon={FaTrash}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => deleteProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Project Changes"
                    reactIcon={FaRegSave}
                    type={'button'}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => onSaveChanges()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Project"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToNextProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Project"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => moveToLastProject()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Change Manager"
                    reactIcon={FaUserTie}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => findPerson()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Manager Change History"
                    reactIcon={FaUserTie}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showManagerChangeHistory()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="PCM Change History"
                    reactIcon={MdHistory}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => showApmChangeHistory()}
                />
            </>
        );
    };

    const displayProjectSettings = () => {
        return (
            <>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'#'}
                    labelOnLeft={true}
                    name={'number'}
                    style={{ width: '30%' }}
                    bodyStyle={{width: '100%' }}
                    register={register}
                />
                <RHFInputBox
                    label={'Name'}
                    labelOnLeft={true}
                    name={'name'}
                    register={register}
                />
                <RHFInputBox
                    label={'Manager'}
                    labelOnLeft={true}
                    name={'manager'}
                    register={register}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'managerName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Mileage Rate:'}
                    labelOnLeft={true}
                    name={'mileageRate'}
                    register={register}
                    style={{width: '40%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '80%' }}
                />
                <RHFInputBox
                    label={'Client ref #'}
                    labelOnLeft={true}
                    name={'clientReferenceNo'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFCheckbox
                    style={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                    labelStyle={{whiteSpace: 'nowrap', verticalAlign: 'middle'}}
                    checked={applyBdBonus}
                    register={register}
                    onChange={() => setApplyBdBonus(!applyBdBonus)}
                    bodyStyle={{ whiteSpace: 'nowrap', verticalAlign: 'middle', width: '16%', marginTop: '.5rem' }}
                    errors={errors}
                    label={'BD Bonus?'}
                    name={'bdBonus'}
                />
                <RHFInputBox
                    label={'BDM:'}
                    labelOnLeft={true}
                    name={'bizDevMgr'}
                    register={register}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'bizDevMgrName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFSelect
                    label={`Client Townships`}
                    name={`easternTownship`}
                    options={[
                        { value: '0', label: 'Load Townships' }
                    ]}
                />
                <RHFInputBox
                    label={'AFE #:'}
                    labelOnLeft={true}
                    name={'afeNumber'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Crew Chief'}
                    labelOnLeft={true}
                    name={'crewChiefNo'}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'crewChiefName'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Orig Office'}
                    labelOnLeft={true}
                    name={'managingOffice'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFSelect
                    label={`Client Landman Reporting`}
                    name={`clientLandmanUse`}
                    register={register}
                    options={[
                        { value: '0', label: 'None' },
                        { value: '1', label: 'CALMS' },
                        { value: '2', label: 'Lease Records' },
                        { value: '3', label: 'Both' },
                    ]}
                />
                <RHFInputBox
                    label={'PC / APM'}
                    labelOnLeft={true}
                    name={'projectCoord'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'projectCoordName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                {projectTypes && <RHFSelect
                    labelOnLeft={true}
                    label="Client Type:"
                    name={`type`}
                    defaultVal={`Oil & Gas Land`}
                    options={projectTypes?.map(ct => {
                        return { value: ct.code, label: ct.description };
                        })}
                    register={register}
                    errors={errors}
                    style={{ width: '100%' }}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />}
                <RHFSelect
                    label="Hide on Invoice?"
                    name="hideProspectOnInvoice"
                    register={register}
                    options={[
                        { value: '0', label: 'Do not Hide' },
                        { value: '1', label: 'Hide' },
                        { value: '2', label: 'Hide County' },
                        { value: '3', label: 'Hide Prospect & County' },
                    ]}
                />
                <RHFInputBox
                    label={'Client Contact'}
                    labelOnLeft={true}
                    name={'clientContact'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'clientContactName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'Approximate Comp Date'}
                    labelOnLeft={true}
                    name={'completionDate'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFSelect
                    label="Commission Split"
                    name={'splitOmp'}
                    register={register}
                    options={[
                        { value: '0', label: 'None' },
                        { value: '1', label: '25%' },
                        { value: '2', label: '33%' },
                        { value: '3', label: '50%' },
                        { value: '4', label: '67%' },
                        { value: '5', label: '75%' }
                    ]}
                />
                <RHFInputBox
                    label={'A/P Contact No'}
                    labelOnLeft={true}
                    name={'clientApContactNo'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={' '}
                    labelOnLeft={true}
                    name={'clientApContactName'}
                    register={register}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'District'}
                    labelOnLeft={true}
                    name={'district'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Project'}
                    labelOnLeft={true}
                    name={'project'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Well Name'}
                    labelOnLeft={true}
                    name={'wellName'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
            </div>
            <div className="form-row" style={{ marginBottom: '0' }}>
                <RHFInputBox
                    label={'ASR Beginning Services/Expenses'}
                    labelOnLeft={true}
                    name={'project'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
                <RHFInputBox
                    label={'Attached Documents'}
                    labelOnLeft={true}
                    name={'attachedDocuments'}
                    register={register}
                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                />
            </div>
            </>
        );
    };

    const AddProjectAndHideDialog = (payload: ProspectDetails) => {
        addProject(payload);
        hideDialog();
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const findClient = () => {
        showDialog(DialogList.FIND_CLIENT);
    };

    const findProject = (addNewProject: boolean) => {
        if (!!addNewProject) {
            setAddingProject(true);
        } else {
            setAddingProject(false);
            showDialog(DialogList.FIND_PROJECT);
        }
    };

    const onSubmit = () => {
        console.log('onSubmit called for save project');
    };

    const onSubmitCounties = (formData: { addCounties: Array<County> }) => {
        setCountiesForUpdate(formData.addCounties);
        alert('Implement onSubmit to save a project');
    };

    const findPerson = () => {
        alert('Implement find landman');
    };

    const showManagerChangeHistory = () => {
        alert('Implement manager change history dialog');
    };

    const showApmChangeHistory = () => {
        alert('Implement APM change history dialog');
    };

    const reportOptions = () => {
        alert('Implement report options');
    };

    const moveToFirstProject = () => {
        if (!!projects && projects?.length > 1) {
            setSelectedProject(projects[0]);
        }
    };

    const moveToNextProject = () => {
        alert('Implement move to next project');
    };

    const moveToLastProject = () => {
        if (!!projects && projects?.length > 1) {
            setSelectedProject(projects[projects.length - 1]);
        }
    };

    const getStateNameFromId = (id: number) => {
        return (states.items.find(s => s.id === id))?.name;
    };

    const generateUpdatePayload = () => {
        const tsdiCounties = countiesForUpdate.map(c => {
            return ({ county: c.name, state: getStateNameFromId(selectedState) });
        });
        const stateString = states.items.find((s) => s.id === selectedState ).name;
        const projectFormData = getValues() as ProspectDetails;
        const payload: Partial<ProspectDetails> = {
            id: selectedProject?.id,
            clientNumber: selectedClient?.clientNumber,
            name: projectFormData.name,
            number: Number(projectFormData.number),
            county: null,
            dayRate: projectFormData.dayRate,
            clientContact: null,
            clientContactName: null,
            mileageRate: null,
            manager: null,
            managerName: null,
            clientReferenceNo: null,
            managinOffice: null,
            bizDevMgr: null,
            bizDevMgrName: null,
            crewChief: null,
            crewChiefName: null,
            bdBonus: null,
            turnkey: null,
            Type: null,
            afeNumber: null,
            district: null,
            creationDate: null,
            completionDate: null,
            project: null,
            splitOmp: null,
            projectCoord: null,
            projectCoordName: null,
            wellName: null,
            easternTownship: null,
            beginningServices: null,
            hideProspectOnInvoice: null,
            clientLandmanUse: null,
            clientApContactNo: null,
            clientApContactName: null,
            attachedDocuments: null,
            backupOfficeRate: null,
            billMode: null,
            billBy: null,
            bopRate: null,
            state: stateString,
            modByNo: null,
            modByName: null,
            counties: tsdiCounties
        };

        return payload as ProspectDetails;
    };

    const onSaveChanges = () => {
        saveCountiesRef.click();
    };

    const moveToPreviousProject = () => {
        alert('Implement move to previous project');
    };

    const generateReports = () => {
        alert('Implement move to previous project');
    };

    const runQuery = () => {
        alert('Run query for client and project');
    };

    const getDayRate = () => {
        let dayRate = 250.00;
        if (!!addingProject) {
            if (!!selectedClient && !!selectedClient?.dayRate) {
                dayRate = selectedClient.dayRate;
            }
        }
        return dayRate;
    };

    const displayCounties = () => {
        return (
            <>
                <table>
                    <thead>
                        <td>
                            State
                        </td>
                        <td>
                            County
                        </td>
                    </thead>
                    <tbody>
                    {selectedProject?.counties?.map((c, index) =>
                        <tr key={index}>
                            <td>
                                {c?.state}
                            </td>
                            <td>
                                {c?.county}
                            </td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </>);
    };

    return (
        <>
        <div>
        <CPNavBar/>
        <ClientProjectSearch
            setSelectedClient={setSelectedClient}
            setSelectedProject={setSelectedProject}
            clients={clients}
            projects={true}
            runQuery={runQuery}
            size={6}
        />
           <div style={{display: 'flex', width: '100vw', justifyContent: 'center'}}>
                <form id={`ProjectMaintenanceForm`} onSubmit={onSubmit}>
                <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <RHFInputBox
                                                name={'clientNumber'}
                                                style={{width: '100%'}}
                                                bodyStyle={{width: '15%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <RHFInputBox
                                                name={'clientName'}
                                                style={{width: '100%'}}
                                                register={registerClientValues}
                                                readOnly={true}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Client"
                                                reactIcon={BsSearch}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Find Landman"
                                                iconImage={`findLandman.png`}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '22px', height: '22px', verticalAlign: 'center'}}
                                                onClick={() => findPerson()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Project"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findProject(true)}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => moveToFirstProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToNextProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToLastProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing Accounts"
                                                reactIcon={FaFileAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => generateReports()}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => window.print()}
                                            />
                                        </div>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displayProjectSettingButtons()}
                                    </div>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        {displayProjectSettings()}
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={'Counties'}>
                                    <div style={{display: 'flex', width: '100%', justifyContent: 'left'}}>
                                    <Form
                                        onSubmit={onSubmitCounties}
                                        mutators={{ ...arrayMutators }}
                                        render={({ handleSubmit, form }) => {
                                            return (
                                                <form onSubmit={handleSubmit}>
                                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                                        <div style={{ display: 'flex', gap: '2rem', width: '98%' }}>
                                                            {selectStates && <RHFSelect
                                                                label="State"
                                                                name="stateId"
                                                                options={selectStates}
                                                                defaultVal={'Select State'}
                                                                onChange={(e) => onStateSelected(Number(e.currentTarget.value))}
                                                                style={{ width: '100%' }}
                                                                register={registerState}
                                                                bodyStyle={{ width: '30%' }}
                                                            />}
                                                            <TagContainer
                                                                label="Counties"
                                                                isTagCreatable={false}
                                                                fieldArrayName="counties"
                                                                fieldAddArrayName="addCounties"
                                                                fieldDeleteArrayName="deleteCounties"
                                                                initialValueName="county"
                                                                form={form}
                                                                selectTags={selectStateCounties ? selectStateCounties : new Array<SelectItem>()}
                                                            />
                                                            <div style={{display: 'flex', justifyContent: 'center', width: '20vw' }}>
                                                                {displayCounties()}
                                                            </div>
                                                            <Button
                                                                style={{display: 'none'}}
                                                                id={'saveCountiesButton'}
                                                                type={'submit'}
                                                                text={'Save Counties'}
                                                            />
                                                        </div>
                                                    </div>
                                                </form>
                                            );
                                        }}
                                    />
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </form>
            </div>
        </div>
            <FindClientDialog
                dialogName={DialogList.FIND_CLIENT}
                hideDialog={hideDialog}
                clients={clients}
                setClientSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                setSelectedClient={setSelectedClient}
            />
            <FindProjectDialog
                dialogName={DialogList.FIND_PROJECT}
                hideDialog={hideDialog}
                setProjectSearchTerm={setClientSearchTerm}
                onCancel={onCancel}
                style={{maxHeight: '50vw'}}
                addNewProject={addingProject}
                setSelectedProject={setSelectedProject}
                mileageRate={currentMileageRate}
                onAddNewProject={AddProjectAndHideDialog}
                clientNumber={selectedClient?.clientNumber}
                dayRate={getDayRate()}
                clientTypes={projectTypes}
            />
        </>
    );
};

export default ProjectMaintenancePage;



// WEBPACK FOOTER //
// ./src/components/client-project/pages/ProjectMaintenancePage.tsx